import {createContext, useState} from "react";
import {Loader} from "../Loader";

export const LoaderContext = createContext(
    undefined
);

export const LoaderProvider = ({
                                   children,
                               }) => {
    const [isVisible, setIsVisible] = useState(false);

    const contextValue = {
        showLoader: () => {
            setIsVisible(true);
        },
        hideLoader: () => {
            setIsVisible(false);
        },
    };

    return (
        <LoaderContext.Provider value={contextValue}>
            {isVisible && <Loader/>}
            {children}
        </LoaderContext.Provider>
    )
};